import { axiosInstance } from "../../../../Services";

export const fetchProjectComments = async (projectCode, limit = 20, page = 1) => {
    if (!projectCode) throw new Error('Project code required');
    try {
      const res = await axiosInstance.get(
        `/internal/pm/listComments/${projectCode}?limit=${limit}&page=${page}`,
        {
          headers: {
            "x-api-key": `${localStorage.getItem('token')}`,
          },
        }
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  